export const RULE_TABS = {
    ACTIVE: {
        key: "PUBLISHED",
        value: "Published"
    },
    INACTIVE: {
        key: "INACTIVE",
        value: "Inactive"
    },
    DRAFT: {
        key: "DRAFT",
        value: "Draft"
    },
}